import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useResearchContext } from "@/context-state/ResearchContext.jsx"
import * as API from '@/services/api.js'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { MainLoader } from "@/components/loader/MainLoader"
import { daysBetweenTimestamps, daysSinceTimestamp } from "@/utils/date"
import { useNavigate } from "react-router-dom";

export const BrandDataProvider = ({ children }) => {

    const { getAdvertisersExternalAdsFromState, updateAdvertisersToExternalAdsMapsState, updateManyExternalAdsState, getAdvertiserFromState, updateManyAdvertiserState } = useResearchContext()
    const { advertiserId } = useParams()
    const navigate = useNavigate()

    const alreadyFetchedForThisAdvertiser = getAdvertisersExternalAdsFromState(advertiserId)

    const fetchBrandData = async () => {
        try {

            const advertiser = getAdvertiserFromState(advertiserId)
            // if advertiser doesn't exist on state, fetch it (probably means the user don't follow the advertiser)
            if (!advertiser) {
                const { data } = await API.getAdvertisers(null, advertiserId)
                if (!data) { // means we can't find the advertiser - the id is probably wrong 
                    navigate('..')
                    return
                }
                updateManyAdvertiserState([data])
            }

            const { data } = await API.getAdvertiserAds(advertiserId)

            // We don't use the unique here! since we need the actual count, including duplicates of same creatives on multiple ads
            // const unique = removeAdsDuplicationsAndAddDaysRunningAmount(data) 
            const adsWithDates = Object.values(
                data.reduce((acc, item) => {
                    const amountOfDays = item.isActive ? daysSinceTimestamp(item.startDate) : daysBetweenTimestamps(item.startDate, item.endDate)
                    item.amountOfDays = amountOfDays <= 0 ? 1 : amountOfDays
                    acc[item._id] = item
                    return acc
                }, {})
            )

            updateManyExternalAdsState(adsWithDates)
            updateAdvertisersToExternalAdsMapsState(advertiserId, data.map(ad => ad._id))
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    useEffect(() => {
        if (!alreadyFetchedForThisAdvertiser) {
            fetchBrandData()
        }
    }, [alreadyFetchedForThisAdvertiser])

    return alreadyFetchedForThisAdvertiser ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat"/>
}